export enum localStorageKey {
  ACCESS_TOKEN = "accessToken",
  REFRESH_TOKEN = "refreshToken",
  USER_DETAILS = "userDetails",
  USER_ROLE = "role",
  FILTER = "filter",
  EXPENSES = "expenses",
  EXPENSE_FORM="expenseForm",
}
